const AllRoutes = {
    // Blog
    blog:"blog",
    // Video
    video:"video",
    // temoignages
    temoignage:"temoignage",
    // contact
    contact:"contact",
    // video
    video:"video",
    // galerie
    photo:"galerie",
    jeux:"jeux",
    about:"a-propos-de-nous",
    donationckeckout:"donationckeckout",
    service:"nos-activites",
    temoignage:"temoignages",
    bible:"la-parole-de-Dieu",
    evenement:"evenements",
    dons:"dons-volontaire",
    ecole:"Ecole-biblique",
    member:"devenir-membre",
    login:"connexion-administrat",

    // Admin 
    admin:`Y68WOELp159r0lDv72ocveNWz6UdK6Veoud18cHPA5N2Jo6t96LNon81N3Ps86ljw73FWvBy12vDD4p2V01AMzCOiiY68WOELp159r0lDv72ocveNWz6UdK6Veoud18cHPA5N2Jo6t96LNon81N3Ps86ljw73FWvBy12vDD4p2V01AMzCOii`,
    message:"tous-les-messages",
    emaillist:"tous-les-emails-recus",
    commentList:"les-comentaires",
    temoins:"temoignages",
    temoins_details:"temoignages-detail",
    activity:"activites",
    memberlist:"membres",
    fildelsList:"fideles",
    userlist:"utlisateurs",
    contentPage:"pages",
    add:"add",
    update:"update"

    
    
    

}



export  default AllRoutes ; 